export const TextAreaModules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike'],
    [{ 'header': '1'}, {'header': '2'},  ],
  
    [{'list': 'ordered'},  
   ],
    ['link', 'image', 'video'],
    ['clean']
  ],
  clipboard: {
    matchVisual: false,
  }
}

export const TextAreaFormats = [
  'header', 'font', 'size',
  'bold', 'italic', 'underline', 'strike', 'blockquote',
  'list', 'bullet', 'indent',
  'link', 'image', 'video'
]